import React, { useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./BarraInferior.css";
import { useData } from "../Pages/DataContext";
import NavigationIcon from "./NavigationIcon";
import {
  getNavigationItems,
  getRoleNavigation,
  isCourseRoute,
  rememberNavigationRole,
} from "../../config/roleNavigation";

const BarraInferior = () => {
  const { data } = useData();
  const location = useLocation();
  const navigation = getRoleNavigation(data?.rol, location.pathname);
  const navigationItems = getNavigationItems(data?.rol, location.pathname);
  const scopeLabel = isCourseRoute(location.pathname)
    ? "Navegación de la clase"
    : `Navegación de ${navigation.label}`;

  useEffect(() => {
    rememberNavigationRole(data?.rol);
  }, [data?.rol]);

  return (
    <nav
      aria-label={scopeLabel}
      className="barra-inferior"
      style={{ "--role-accent": navigation.accent }}
    >
      {navigationItems.map((navigationItem) => (
        <NavLink
          className={({ isActive }) =>
            `role-nav-link${isActive ? " role-nav-link-active" : ""}`
          }
          key={`${navigation.roleKey}-${navigationItem.path}`}
          to={navigationItem.path}
        >
          <span className="role-nav-icon">
            <NavigationIcon name={navigationItem.icon} size={24} />
          </span>
          <span className="role-nav-label">{navigationItem.label}</span>
        </NavLink>
      ))}
    </nav>
  );
};

export default BarraInferior;
